/* Behaviour for the FunnyFuzzy recreation.
   Mirrors the motion measured on the reference: scroll reveals, horizontal
   scrollers with arrow buttons, countdown bar, sticky buy bar, gallery. */

(function () {
  "use strict";

  /* ---- scroll reveal --------------------------------------------------
     Items inside a horizontal scroller are clipped by their own overflow
     box, so an observer on the item itself never fires for cards parked
     off-screen right. Those are revealed per track instead. */
  var revealTargets = [].slice.call(document.querySelectorAll(".reveal"));

  if (!("IntersectionObserver" in window)) {
    revealTargets.forEach(function (el) { el.classList.add("is-in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var target = entry.target;
        if (target.classList.contains("scroller")) {
          target.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
        } else {
          target.classList.add("is-in");
        }
        io.unobserve(target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });

    revealTargets.forEach(function (el) {
      if (!el.closest(".scroller")) io.observe(el);
    });
    document.querySelectorAll(".scroller").forEach(function (track) {
      if (track.querySelector(".reveal")) io.observe(track);
    });
  }

  /* ---- horizontal scrollers ------------------------------------------ */
  function updateArrows(track) {
    var prev = document.querySelector('.scroller-btn--prev[data-scroll="' + track.id + '"]');
    var next = document.querySelector('.scroller-btn--next[data-scroll="' + track.id + '"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = track.scrollLeft >= max;
  }

  document.querySelectorAll(".scroller").forEach(function (track) {
    updateArrows(track);
    track.addEventListener("scroll", function () { updateArrows(track); }, { passive: true });
    window.addEventListener("resize", function () { updateArrows(track); });
  });

  document.querySelectorAll(".scroller-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var track = document.getElementById(btn.dataset.scroll);
      if (!track) return;
      var first = track.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      var pages = Math.max(1, Math.floor(track.clientWidth / step));
      track.scrollBy({ left: step * pages * Number(btn.dataset.dir), behavior: "smooth" });
    });
  });

  /* ---- announcement countdown ---------------------------------------- */
  var cd = document.querySelectorAll("[data-cd]");
  if (cd.length) {
    var deadline = new Date();
    deadline.setDate(deadline.getDate() + 2);
    deadline.setHours(23, 59, 59, 0);

    var tick = function () {
      var left = Math.max(0, deadline - new Date());
      var s = Math.floor(left / 1000);
      var parts = {
        days: Math.floor(s / 86400),
        hours: Math.floor((s % 86400) / 3600),
        minutes: Math.floor((s % 3600) / 60),
        seconds: s % 60
      };
      cd.forEach(function (el) {
        var v = parts[el.dataset.cd];
        el.textContent = v < 10 ? "0" + v : String(v);
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- product gallery ------------------------------------------------ */
  var main = document.getElementById("gallery-main");
  if (main) {
    document.querySelectorAll("#gallery-thumbs .gallery__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        document.querySelectorAll("#gallery-thumbs .gallery__thumb").forEach(function (t) {
          t.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
        main.src = thumb.dataset.full;
      });
    });
  }

  /* ---- variant pickers ------------------------------------------------ */
  document.querySelectorAll("[data-option-group]").forEach(function (group) {
    group.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-value]");
      if (!btn) return;
      group.querySelectorAll("button[data-value]").forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      var out = document.querySelector("[data-selected-" + group.dataset.optionGroup + "]");
      if (out) out.textContent = btn.dataset.value;
      // the option name is store data and is now German, so its handle is
      // "farbe", not "color". Key off the swatch grid class instead.
      if (group.classList.contains("color-grid")) {
        var img = btn.querySelector("img");
        if (img && main) main.src = img.getAttribute("src");
      }
    });
  });

  /* ---- quantity steppers ---------------------------------------------- */
  document.querySelectorAll(".quantity").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("button[data-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty);
        input.value = Math.max(1, next);
      });
    });
  });

  /* ---- sticky buy bar -------------------------------------------------- */
  var sticky = document.getElementById("sticky-buy");
  var buyRow = document.querySelector(".product-page .buy-row");
  if (sticky && buyRow) {
    var queued = false;
    var syncSticky = function () {
      queued = false;
      sticky.classList.toggle("is-visible", buyRow.getBoundingClientRect().bottom < 0);
    };
    // read the live rect rather than the entry's cached one, so a jump scroll
    // (anchor link, restored position) lands in the right state too
    window.addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(syncSticky);
    }, { passive: true });
    syncSticky();
  }
})();
